import React from 'react';
import PropTypes from 'prop-types';

import { TableBody as MUITableBody } from '@material-ui/core';

export const TableBody = props => <MUITableBody {...props} />;

TableBody.propTypes = {
  classes: PropTypes.object,
  component: PropTypes.elementType
};

export default TableBody;
